import { EntityDoc4det } from "../../entity/EntityDoc4det";

export class DtoDoc4detsPostRes extends EntityDoc4det {}
